import { Outlet } from 'react-router-dom'

const Token = () => <Outlet />

export default Token
